// Served by GET /api/public-config. Fetched once per page load; a failed fetch isn't cached,
// so the next caller retries instead of seeing "no sign-in methods" until a reload.
export type PublicConfig = {
	authMethods: { emailPassword: boolean; google: boolean }
	trustedOrigins: string[]
	/** Set only on the client-side fallback when the server couldn't be reached. */
	unavailable?: true
}

const fallback: PublicConfig = {
	authMethods: { emailPassword: false, google: false },
	trustedOrigins: [],
	unavailable: true
}

let config: Promise<PublicConfig> | undefined
export const publicConfig = () =>
	(config ??= fetch('/api/public-config')
		.then((r) => {
			if (!r.ok) throw new Error(`public-config ${r.status}`)
			return r.json() as Promise<PublicConfig>
		})
		.catch(() => {
			config = undefined
			return fallback
		}))
